app.controller('modalDeleteAwbReasonCtrl', function ($scope, $uibModalInstance, params) {
    function normalizeTextValue(value) {
        return String(value === undefined || value === null ? '' : value).trim();
    }

    $scope.title = params && params.title ? params.title : 'Alasan Hapus AWB';
    $scope.entryLabel = params && params.entryLabel ? params.entryLabel : 'Outbound';
    $scope.awb = params && params.awb ? params.awb : '';
    $scope.errorText = '';
    $scope.form = {
        reason: normalizeTextValue(params && params.reason)
    };

    $scope.submit = function () {
        var normalizedReason = normalizeTextValue($scope.form.reason);

        if (!normalizedReason) {
            $scope.errorText = 'Reason delete wajib diisi';
            return;
        }

        $uibModalInstance.close({
            reason: normalizedReason
        });
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});